import React from "react";
import { LOW_STOCK_LIMIT } from "../../../public/Constants/EnumConstants";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";

const LowStockIndicator = ({ smallerText, remainingStock }) => {
    return remainingStock > LOW_STOCK_LIMIT ? null : (
        <TypographyPoppins
            color={
                remainingStock === 1
                    ? "error"
                    : remainingStock === 0
                        ? "Text_Gray"
                        : "Low_Stock"
            }
            customStyle={`${smallerText ? "!text-xs" : "!text-sm"} ${smallerText ? "md:!text-sm" : "md:!text-base"
                } capitalize`}
            fontWeight="medium"
            text={
                remainingStock === 0
                    ? "Out of Stock"
                    : remainingStock === 1
                        ? "Last One"
                        : remainingStock < LOW_STOCK_LIMIT
                            ? "Low Stock"
                            : ""
            }
        />
    );
};

export default LowStockIndicator;
